<template>
	<div id="app" class="container-fluid h-100" style="padding:0px">
		<div v-if="userInfo">
			<div>
				<app-header style="width:100%; z-index: 1021;" :appbus="APPBUS"/>
				<div class="col" style="padding: 0px;" v-if="!isUserNoAccess(userInfo)">
					<router-view :appbus="APPBUS"/>
					<b-modal id="fsNotificationModal" size="xl" centered  scrollable hide-footer hide-header body-bg-variant="success" @hide="notificationWatcher">
						<div class="fsNotificationTestSize text-center text-light" >{{newOrderCount}}</div>
						<b-button size="sm" variant="primary" block @click="$bvModal.hide('fsNotificationModal')">Ok</b-button>
					</b-modal>				
				</div>
				<div v-else>
					You dont have access yet.
				</div>
			</div>
		</div>
		<login v-else/>
	</div>	
</template>

<script>
import Header from "@/components/portal/layouts/Header.vue";
import Login from "@/views/portal/Login.vue";
import Vue from 'vue'

import { mapState } from 'vuex'
import * as Ably from "ably";
const soundMp3 = require("@/assets/sound/sound.mp3");

export default {
	components: {
		"app-header": Header,
		"login": Login
	},
	computed: { 
		...mapState({
			userInfo: 'userInfo',
			store: 'store',
			stateOrders: 'stateOrders',
			setting : "setting"
		}),
		getOS() {
          return this.$store.getters.getOrderStatus
		},
		newOrder() {
			return this.stateOrders.filter(({status}) => { return status === this.getOS.New.value })
		},
		newOrderCount() {
			if(this.countNewOrders === -1 ){
				return this.newOrder.length
			}else{
				return this.countNewOrders
			}
		}			
	},
	watch:{
		userInfo(){
			if(this.userInfo){
				this.selectedLocation = this.userInfo.location
				this.startAbly()
			}
		},
		setting() {
			this.notificationWatcher()
		},
		// newOrderCount(newValue) {
		// 	if(newValue === 0) {
		// 		//we can hide in this case
		// 	}
		// }		
	},
	data(){
		return {
			audio : null,
			countNewOrders : -1, 
			APPBUS : new Vue(),
			ably : null, 
			channel : null,
			watchNotificationTimer : null,
		}
	},
	methods:{
		showFSNotification() {
			let {isShow, playBeep} = this.setting.notification
			if(isShow) {
				this.$bvModal.show("fsNotificationModal")
			}
			if(playBeep) {
				this.playSound()
			}
		},
		playSound() {
			if(this.audio) {
				this.audio.pause()
			}
			this.audio = new Audio(soundMp3);
			this.audio.play();
		},
		startAbly() {			
			const ablyKey = this.userInfo ?  this.userInfo.ablyKey : ""
			let channelName = this.selectedLocation ? this.selectedLocation._id : ""
			if (!ablyKey || !channelName){
                console.log("isAblyKeyEmpty -> ",ablyKey, channelName)
                return
            }
			if(this.channel) {				
				this.channel.unsubscribe('locationSettings');
				this.channel.unsubscribe('orderStatus');
				this.APPBUS.$emit("orderStatusOff")
			}
			console.log("ably channel name",channelName)
            this.ably = new Ably.Realtime(ablyKey);
            this.channel = this.ably.channels.get(channelName);
            this.channel.subscribe('orderStatus', this.ablyEventListener);
			this.channel.subscribe('locationSettings', this.ablyLocationUpdateEventListener);
		}, 
		notificationWatcher() {
			if(this.watchNotificationTimer) {
				clearTimeout(this.watchNotificationTimer)
			}
			let {idealTime , isShow} = this.setting.notification
			if(isShow) {
				this.watchNotificationTimer = setTimeout(()=> { 
					if(this.newOrderCount > 0) {
						this.showFSNotification()
					} else {
						this.notificationWatcher()
					}
				}, idealTime  * 1000)
			}
		},
		ablyEventListener({data}) {
			// for (var property in message.data) {}
			// console.log("ablyEventListener", data)
			this.countNewOrders = data.countNewOrders
			if(data.status === this.getOS.New.value) {
				this.showFSNotification()
				this.toast(this, { msg :  "New Order", variant : "success" , appendToast : true})
			}
			this.APPBUS.$emit("orderStatus", data)
		},
		async ablyLocationUpdateEventListener({data}) {
			await this.$store.dispatch('apiMe')
			console.log("LocationUpdated", data)
		}
	},
	mounted(){ 		
		if(this.userInfo) {
			this.selectedLocation = this.userInfo.location
			this.startAbly()
		}
		this.notificationWatcher()
	},
	destroyed(){
		if(this.channel) {
			this.channel.unsubscribe('orderStatus');
		}
	}
};
</script>

<style lang="scss">
	html, body {
		height:100%;
	}	
	@media print
	{    
		.no-print, .no-print *
		{
			display: none !important;
		}
	}
</style>
<style scoped>
	.fsNotificationTestSize {
		font-size: 50vmin;
	}
</style>
<!--
<style lang="scss" scoped>
	#fsNotificationModal >>> .modal-dialog{
		height: 100% !important;
	}
	#fsNotificationModal >>> .modal-content{
		height: 100% !important;
	}
</style>
-->